import React from "react";
import "../styles/components/_footer.scss";
const Copyright = () => {
  return (

<div className="copyright">
<p>© {new Date().getFullYear()} Mevedir. All rights reserved.</p>
</div>
  );
};

export default Copyright;
